"use client";

import React from "react";
import { useLayout } from "@/lib/context/layout";
import { AppMenu } from "./AppMenu";

export const AppSidebar = () => {
    const { enableDashboards } = useLayout();

    if (!enableDashboards) {
        return <></>;
    }

    return (
        <div
            className="fixed z-[999] overflow-y-auto overflow-x-hidden select-none bg-card border-r border-border p-2"
            style={{
                width: "var(--sidebar-width-collapsed)",
                height: "calc(100vh - var(--topbar-height))",
                top: "var(--topbar-height)",
                left: 0,
                transition: "width 0.2s ease, box-shadow 0.2s ease",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.width = "var(--sidebar-width-expanded)";
                e.currentTarget.style.boxShadow = "var(--shadow-hover, 0 4px 12px rgba(0,0,0,0.1))";
                e.currentTarget.style.zIndex = "1000";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.width = "var(--sidebar-width-collapsed)";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.zIndex = "999";
            }}
        >
            <AppMenu />
        </div>
    );
};
